import Vue from 'vue'

export let bus = new Vue()



// WEBPACK FOOTER //
// ./src/shared/bus.js